import { render, staticRenderFns } from "./TaxSummary.vue?vue&type=template&id=042fe74e&scoped=true"
import script from "./TaxSummary.vue?vue&type=script&lang=js"
export * from "./TaxSummary.vue?vue&type=script&lang=js"
import style0 from "./TaxSummary.vue?vue&type=style&index=0&id=042fe74e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042fe74e",
  null
  
)

export default component.exports